export enum TransactionRefundBlockedExplanation {
    MISSING_PERMISSIONS = 'MISSING_PERMISSIONS',
    ALREADY_REFUNDED = 'ALREADY_REFUNDED',
    NO_DIGITAL_PURCHASE = 'NO_DIGITAL_PURCHASE',
    NO_ACTIVE_ACCOUNT_TO_REFUND = 'NO_ACTIVE_ACCOUNT_TO_REFUND',
    PAST_REFUND_TIME = 'PAST_REFUND_TIME',
    NON_POSITIVE_PRICE = 'NON_POSITIVE_PRICE',
    PARKING_NOT_COMPLETE = 'PARKING_NOT_COMPLETE',
    CONTRACT_TYPE_NOT_SUPPORTED = 'CONTRACT_TYPE_NOT_SUPPORTED',
    NO_SUBSCRIPTION_CHARGE = 'NO_SUBSCRIPTION_CHARGE',
    PAYMENT_CHANNEL_NOT_SUPPORTED = 'PAYMENT_CHANNEL_NOT_SUPPORTED',
}

export interface OperatorRefund {
    refundedAt: string;
    refundedBy: string;
    refundAmountRappen: number;
    remark: string;
}

export interface TransactionRefundInputValues {
    amount: string;
    remark: string;
}

export interface TransactionRefundPayload {
    contractExternalId: string;
    amountRappen: number;
    remark: string;
}

export function parseChf(price: string) {
    return parseFloat(parseFloat(price).toFixed(2));
}

export function isRefundAmountTooHigh(amount: number, refundAmount: number) {
    return refundAmount ? refundAmount > amount : false;
}

export function isInputAmountRefundable(price: number, inputAmount: number) {
    return (
        !isNaN(inputAmount) &&
        inputAmount !== 0 &&
        !isRefundAmountTooHigh(price, inputAmount)
    );
}
